<template>
  <div>
     <h1 class="admin-title">Blog <el-button style="float:right;" size="small" @click="newPost" type="primary">New Post</el-button></h1>
      <div class="admin-container">
         <el-table
          v-loading="loading"
          :data="posts"
          style="width: 100%">
          <el-table-column
            prop="attributes.image"
            label="Image"
            width="100">
            <template slot-scope="scope">
              <img :src="scope.row.attributes.image" style="width:80px; margin:10px;">
            </template>
          </el-table-column>
          <el-table-column prop="attributes.name" label="Title">
            <template slot-scope="scope">
              <h3>{{scope.row.attributes.name}}</h3>
            </template>
          </el-table-column>
          <el-table-column prop="attributes.previewText" label="Preview Text" width="280">
            <template slot-scope="scope">
            <p>{{scope.row.attributes.previewText}}</p>
          </template>
          </el-table-column>
          <el-table-column
            prop="attributes.image"
            label="Status"
            >
            <template slot-scope="scope">
              <el-tag size="mini" type="success" v-if="scope.row.attributes.status=='PUBLISHED'">PUBLISHED</el-tag>
              <el-tag size="mini" type="warning" v-if="scope.row.attributes.status=='DRAFT'">DRAFT</el-tag>
              <el-tag size="mini" type="info" v-if="scope.row.attributes.status=='SCHEDULED'">SCHEDULED</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="">
            <template slot-scope="scope">
              <el-button class="edit-btn"
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
  </div>
</template>

<script>
import ArticlePreview from './article-preview';
import moment from 'moment';
export default {
  components: {ArticlePreview},
  mounted() {
    this.$nextTick(function () {
        this.getPosts();
    });
  },
  data () {
    return {
      loading: true,
      posts:[],
      savingData: false,
      msg: 'This is the login',
      userData:{
        email:"",
        password:""
      }
    }
  },
  watch: {
    posts (val) {
      val.forEach(post => {
        //console.log(post.attributes.publishedDate);
        // if(post.attributes.status === 'SCHEDULED' && post.attributes.publishedDate){
        //   if(moment().diff(post.attributes.publishedDate, 'minutes') >= 0){
        //     //published post
        //     post.set('status', 'PUBLISHED');
        //     post.save();
        //   }
        // }
        const regex = /data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-zA-Z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*/gm;
        var postContent = post.attributes.content;
        const base64Images = postContent.match(regex);
        if(base64Images){
          base64Images.forEach(img => {
            window.fsClient.upload(img).then(res => {
              postContent = postContent.replace(img, res.url);
              post.set("content", postContent);
              post.save();
            });
          })
        }
      })
    }
  },
  methods:{
    getPosts() {
      var postQuery = new Parse.Query('Post');
      //postQuery.limit(4);
      postQuery.find()
        .then(results =>{
          this.posts = results;
          this.loading = false;
        })
        .catch(function(err){
          alert('ERROR GETTING POST');
        });
    },
    goToSignup() {
      this.$router.push('/signup/plan');
    },
    newPost() {
      this.$router.push('/admin-panel/content/form');
    },
    handleEdit(index, row) {
      this.$router.push('/admin-panel/content/form/'+row.id);
    }
  }
}
</script>

<style scope>
.article-container .main-image{
  height: 300px;
  background-size: cover;
}
.article-container h1 {
  width: 100%;
  text-align: left;
  padding: 20px 30px 5px;
  margin: 0;
  color: #666;
}
.article-body {
  padding: 0 30px;
  text-align: left;
  margin-bottom: 30px;
}
.article-body p{
  margin:5px 0 10px;
  color: #999;
  line-height: 26px;

}
.read-more-btn{
  margin: 10px auto 30px;
}
.el-table .cell {
  text-align: left;
}
.el-table .cell  h3{
  font-size: 14px;
}
.el-table .cell  button{
  float: right;
}
.el-table .cell  p{
  font-size: 12px;
  color: #999;
}
</style>
